import * as React from "react";

interface SectionTitleProps {
  showDecorators?: boolean;
}

export const SectionTitle: React.FunctionComponent<SectionTitleProps> = (
  props
) => {
  return (
    <div
      className={`bbnt_homepage_section_title section-title ${
        props.showDecorators ? "show-decorators" : "hide-decorators"
      }`}
    >
      <div className="decorator left" />
      <h2 className="title">{props.children}</h2>
      <div className="decorator right" />
    </div>
  );
};
